import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { VerificationServiceChangeRequest } from "@idw-types/data/verification-service";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";

type CreateVerificationServiceChangeRequestModalProps = {
    serviceName: string;
    apiKey: string;
    onSubmitHandler: (onModalClose: () => void) => Promise<VerificationServiceChangeRequest>;
    onModalClose: () => void;
};

export const CreateVerificationServiceChangeRequestModal = (props: CreateVerificationServiceChangeRequestModalProps) => {
    const { serviceName, apiKey, onModalClose, onSubmitHandler } = props;

    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>
                    This action will <b>START</b> a new Change Request to
                    MODIFY the Verification Service named <b>{serviceName}</b> with 
                    API Key <b>{apiKey}</b>.
                </p>
                <p>
                    When you have finished modifying the Verification Service, SUBMIT the Change Request for review to continue the process.
                    You may also CANCEL the Change Request at any time prior to deployment using the CANCEL option.
                </p>
            </div>
        );
    }, []);

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.CREATE}
            title={"Start Change Request"}
            body={bodyElement}
            buttonText={"Start Change Request"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};